<template>
  <div class="bg-dark p-4">
    <!-- should this actually just be the vue components themselves with the global state managed here? -->
    <div class="nav hvh-flex column">
      <p class="button" v-for="(key, index) in Object.keys(tabs)" :key="index">
        <button :class="{ 'active-tab': key === value }" @click="$emit('input', key)">{{ tabs[key].name }}</button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'tabs'],
}
</script>


<style lang="scss" scoped>
.button {
  button {
    background-color: rgba(185, 192, 210, 0.14);
    width: 100%;
    color: #8c9093;
    font-weight: bold;
    letter-spacing: 0.3px;
    padding: 5px 5px;
    border-radius: 5px;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    text-align: center;
    display: inline-block;
    white-space: nowrap;

    &.active-tab {
      background-color: #060a41;
      color: rgb(255, 255, 255);
    }
  }
}
</style>